import { useQuery } from "@tanstack/react-query";
import { FILTER_OPERATIONS, QueryBuilder } from "features/members";
import { axios } from "lib/axios";

export const getSystemLogsPaginated = ({
  churchId,
  page,
  pageSize,
  isDenomination = false,
  denominationId,
  queries
}) => {
  const queryBuilder = new QueryBuilder();

  queryBuilder.pagination(page, pageSize);

  if (queries.search) {
    queryBuilder.search(queries.search);
  }

  if (queries.startDate && queries.endDate) {
    queryBuilder.filter({
      updated_at: [
        {
          operator: FILTER_OPERATIONS.BETWEEN,
          value: [queries.startDate, queries.endDate]
        }
      ]
    });
  }

  if (queries.filter) {
    queryBuilder.filter(queries.filter);
  }

  const queryString = queryBuilder.build();

  return axios.get(
    `/${isDenomination ? "denominations" : "churches"}/${
      isDenomination ? denominationId : churchId
    }/logs-paginated${queryString}`
  );
};

export const useSystemLogsPaginated = ({
  churchId,
  page,
  pageSize,
  isDenomination = false,
  denominationId,
  queries = {},
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "system-logs",
      page,
      pageSize,
      isDenomination ? denominationId : churchId,
      JSON.stringify(queries)
    ],
    queryFn: () =>
      getSystemLogsPaginated({
        churchId,
        page,
        pageSize,
        isDenomination,
        denominationId,
        queries
      })
  });
};
